import { render, staticRenderFns } from "./NotifyMeFor.vue?vue&type=template&id=ee0b214a&scoped=true&"
import script from "./NotifyMeFor.vue?vue&type=script&lang=js&"
export * from "./NotifyMeFor.vue?vue&type=script&lang=js&"
import style0 from "./NotifyMeFor.vue?vue&type=style&index=0&id=ee0b214a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0b214a",
  null
  
)

export default component.exports